import { rebaseText } from '@superfunnel/utils/agent-changes';

import { parseHtmlAndFindElement } from '../../utils/html-element-utils';

interface ElementEdit {
  content: unknown;
  baseContent?: string;
}

const getInnerHtml = (html: string, elementPath: string) =>
  parseHtmlAndFindElement(html, elementPath)?.element.innerHTML;

const normalizeInnerHtml = (innerHtml: string) => {
  const element = document.createElement('div');
  element.innerHTML = innerHtml;
  return element.innerHTML;
};

/**
 * The inner HTML an element edit should write. When the canvas reported what
 * the element showed before the edit and the element changed since (another
 * tab, the agent), the edit is re-applied onto the newer text instead of
 * overwriting it; undefined when that is not possible. Without a reported
 * base the edit overwrites, as before.
 */
export const mergeElementEdit = (
  html: string,
  elementPath: string,
  edit: ElementEdit,
): string | undefined => {
  const mine = edit.content as string;
  const current = getInnerHtml(html, elementPath);
  if (edit.baseContent === undefined || current === undefined) return mine;

  const base = normalizeInnerHtml(edit.baseContent);
  const normalizedMine = normalizeInnerHtml(mine);
  if (current === base || current === normalizedMine) return mine;
  return rebaseText(current, base, normalizedMine);
};
